import React, { forwardRef } from 'react';

import type { AutocompleteRenderInputParams } from '@mui/material';
import type { AlineInputProps } from 'src/AlineInput';
import { AlineInput } from 'src/AlineInput';

type AlineAutocompleteInputProps = AutocompleteRenderInputParams &
  AlineInputProps & {
    inputClassName?: string;
  };

export const AlineAutocompleteInput = forwardRef(function AlineAutocompleteInput(
  props: AlineAutocompleteInputProps,
  ref: React.Ref<HTMLInputElement>
): JSX.Element {
  /**
   * Since AlineInput uses InputBase directly and not TextField, it has a slightly different API, which means we need to spread InputProps
   * and the rest of the params at a top-level for them to work correctly with MUIs Autocomplete component.
   *
   * `inputProps` is destructured out of `rest` and explicitly merged on top of
   * `slotProps.htmlInput`, so caller-passed `inputProps` (e.g. a `data-cy`
   * attribute) extends rather than races the autocomplete's html-input props.
   */
  const { classes, inputProps: callerInputProps, slotProps, ...rest } = props;
  return (
    <AlineInput
      ref={slotProps.input.ref}
      classes={{ ...classes, root: slotProps.input.className }}
      endAdornment={slotProps.input.endAdornment}
      inputProps={{ ...slotProps.htmlInput, ...callerInputProps }}
      inputRef={ref}
      startAdornment={slotProps.input.startAdornment}
      {...rest}
    />
  );
});
